module.exports = {"540327100":"旺达镇","540327101":"田妥镇","540327102":"扎玉镇","540327203":"东坝乡","540327204":"仁果乡","540327207":"绕金乡","540327208":"碧土乡","540327210":"美玉乡","540327211":"中林卡乡","540327212":"下林卡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540327.json
// module id = 2848
// module chunks = 0